import {
	Card,
	CardContent,
	CardHeader,
	Checkbox,
	Collapse,
	IconButton,
	ListItemText,
	makeStyles,
	MenuItem,
	TextField,
	Typography,
	Icon,
	Button
} from '@material-ui/core'
import { ExpandMoreOutlined } from '@material-ui/icons'
import Autocomplete from '@material-ui/lab/Autocomplete'
import clsx from 'clsx'
import { cloneDeep } from 'lodash'
import React, { useEffect, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import debouncedInput from '../../../services/debouncedInput'
import { USER_ROLES } from '../../../utils/enums'
import { DeletableChip } from '../../Misc/DeletableChip'
import GroomingDurationTable from '../../Tables/GroomingDurationTable'
import { GROOMING_LEVELS } from '../../../utils/constants'
import { purple } from '../../../utils/colors'
import { FONT_WEIGHTS } from '../../../utils'
import useConstants from '../../../hooks/useConstants'

const coatOptions = ['Short', 'Medium', 'Long', 'Extra-Long', 'Variable']
const coatTypes = [
	'Combination',
	'Corded',
	'Curly',
	'Double',
	'Drop',
	'Hairless',
	'Heavy',
	'Short',
	'Silky',
	'Smooth',
	'Wavy',
	'Wire (Long)',
	'Wire (Short)',
	'Doodle (Shaggy)',
	'Doodle (Wavy)',
	'Doodle (Curly)',
	'Doodle (Wool)'
]

const sheddingOptions = [
	'none',
	'some - always',
	'some - seasonal',
	'some - seasonish',
	'significant - always',
	'significant - seasonal',
	'significant - seasonish',
	'excessive - always',
	'excessive - seasonal',
	'excessive - seasonish'
]
const DebouncedTextField = debouncedInput(TextField, { timeout: 200 })

const duration_tables = [
	'None',
	'coat-combo',
	'coat-corded',
	'coat-curly',
	'coat-doodle',
	'coat-double',
	'coat-wavy',
	'coat-hairless',
	'coat-heavy',
	'coat-short',
	'coat-silky',
	'coat-smooth',
	'coat-wire-l',
	'coat-wire-s',
	'golden',
	'lab',
	'cavalier-spaniel',
	'frenchie',
	'bernese',
	'corgi',
	'german-shepherd',
	'yorkie',
	'westie',
	'shih-tzu',
	'aussie',
	'poodle'
]

const useStyles = makeStyles((theme) => ({
	header: {
		padding: '13px 24px',
		userSelect: 'none',
		cursor: 'pointer',
		'& .MuiCardHeader-action': {
			margin: 0
		}
	},
	grid: {
		display: 'grid',
		gridGap: '23px',
		marginBottom: '23px',
		'&:last-child': {
			marginBottom: 0
		}
	},
	gridDouble: {
		gridTemplateColumns: 'repeat(auto-fill, minmax(424px, 1fr))',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				minWidth: '424px !important'
			}
		}
	},
	rowSplit: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: 23
	},
	gridTriple: {
		gridTemplateColumns: 'repeat(auto-fill, minmax(274px, 1fr))',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				minWidth: '274px !important'
			},
			'& .MuiFormControl-root': {
				minWidth: '272px !important'
			}
		}
	},
	fullWidth: {
		width: '100%'
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	footerButton: {
		fontFamily: 'Nunito',
		fontWeight: '800',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		}
	},
	chip: {
		marginRight: 4
	},
	sectionHeader: {
		fontWeight: '800',
		fontSize: 16,
		color: '#1A1A35',
		marginBottom: 14,
		marginTop: 8
	},
	stuff: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		marginBottom: 16
	},
	wizardButtonContainer: {
		marginBottom: '2rem',
		'& .MuiButtonBase-root': {
			padding: 0,
			'& .MuiButton-label': {
				fontSize: '0.875rem',
				fontWeight: FONT_WEIGHTS.ExtraBold
			}
		},
		'& .MuiButtonBase-root:hover': { backgroundColor: 'transparent' }
	}
}))

const GroomingServicesCard = (props) => {
	const classes = useStyles()
	const { tags } = useConstants()
	const user = useSelector((state) => state.general?.user?.user)
	const canEditExtraGroomTime =
		user?.roles?.includes(USER_ROLES.BackOfficeUser) ||
		user?.roles?.includes(USER_ROLES.SuperUser) ||
		false

	let {
		pet,
		setPet,
		/*facilityPermittedMealAdjustments,*/ facility,
		setIsSaveShown,
		openGroomingProfileWizard
	} = props


	// const cadences = ['morning', 'midday', 'evening']
	// const bowlAdjustments = [
	// 	'None',
	// 	'Slow Feeder',
	// 	'Tennis Ball',
	// 	'Mini Bowl In Center',
	// 	'Flat-Faced Bowl',
	// 	'Raised Bowl',
	// 	'Metal Bowl',
	// 	'Slow Feeder Metal Bowl'
	// ]

	const [isExpanded, setIsExpanded] = useState(false)
	const [petGroomingTags, setPetGroomingTags] = useState([])
	const [groomingOptions, setGrooming] = useState([])
	const [groomingAddOnOptions, setGroomingAddOnOptions] = useState([])
	const [groomingAddOns, setGroomingAddOns] = useState([])

	const handleOpenGroomingProfileWizard = useCallback(() => {
		if (openGroomingProfileWizard) {
			openGroomingProfileWizard()
		}
	}, [openGroomingProfileWizard])

	useEffect(() => {
		if (tags && pet.tags && pet.tags.grooming && pet.tags.grooming.length) {
			let groomingTags = tags.grooming.filter((tag) => {
				return pet.tags.grooming.findIndex((pt) => pt._id === tag._id) !== -1
			})

			setPetGroomingTags(groomingTags)
		} else {
			setPetGroomingTags([])
		}

		if (pet?.allowed_grooming_services) {
			const groomingServices = facility?.services?.grooming?.services || []

			const grooms = pet.allowed_grooming_services
				.map((s) => groomingServices.find((serv) => serv.type === s))
				.filter(Boolean)
			setGrooming(grooms)
		}

		if (facility?.addOnTypes?.length) {
			const groomAdds = facility.addOnTypes.filter((a) => a.grooming_service)
			setGroomingAddOnOptions(groomAdds)
		}

		if (pet?.grooming_addons && facility?.addOnTypes?.length) {
			const allowed = pet.grooming_addons
				.map((type) => facility.addOnTypes.find((t) => t.grooming_addon_type === type))
				.filter(Boolean)
			setGroomingAddOns(allowed)
		}
	}, [tags, pet, facility])

	const updatePet = (field, value) => {
		setPet({ ...pet, [field]: value })
		setIsSaveShown(true)
	}

	const updateGroomingTags = (value) => {
		let updatedTags = cloneDeep(pet.tags)

		updatedTags['grooming'] = value

		updatePet('tags', updatedTags)
	}

	const removeTag = (value) => {
		let updatedTags = cloneDeep(pet.tags)
		let tagIndex = updatedTags['grooming'].findIndex((t) => t._id === value._id)

		if (tagIndex !== -1) {
			updatedTags['grooming'].splice(tagIndex, 1)
		}

		updatePet('tags', updatedTags)
	}

	const removeService = (obj) => {
		const newOnes = pet.allowed_grooming_services.filter((s) => s !== obj.type)
		updatePet('allowed_grooming_services', newOnes)
	}

	const addService = (arr) => {
		const newOnes = arr.map((a) => a.type)
		updatePet('allowed_grooming_services', newOnes)
	}

	const removeAddOn = (obj) => {
		const newOnes = pet.grooming_addons.filter((s) => s !== obj.grooming_addon_type)
		updatePet('grooming_addons', newOnes)
	}

	const addAddOn = (arr) => {
		const newOnes = arr.map((a) => a.grooming_addon_type)
		updatePet('grooming_addons', newOnes)
	}

	return (
		<Card>
			<CardHeader
				title="Grooming Services"
				className={classes.header}
				onClick={() => setIsExpanded(!isExpanded)}
				action={
					<IconButton
						className={clsx(classes.expand, {
							[classes.expandOpen]: isExpanded
						})}
						onClick={() => setIsExpanded(!isExpanded)}
						aria-expanded={isExpanded}
						aria-label="show more">
						<ExpandMoreOutlined style={{ fill: '#777679' }} />
					</IconButton>
				}
			/>
			<Collapse in={isExpanded} timeout="auto" unmountOnExit>
				<CardContent>
					<Typography variant="body1" className={classes.sectionHeader}>
						Grooming Profile Setup
					</Typography>
					<div className={classes.wizardButtonContainer}>
						<Button
							endIcon={
								<Icon
									className={`fal fa-bring-forward`}
									style={{
										fontWeight: '900',
										fontSize: '16px',
										color: purple[500],
										width: 20
									}}
								/>
							}
							variant="text"
							color="secondary"
							onClick={handleOpenGroomingProfileWizard}>
							Open Profile Setup Wizard
						</Button>
					</div>
					<Typography variant="body1" className={classes.sectionHeader}>
						Service Specifics
					</Typography>
					<div className={classes.grid}>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
							<Autocomplete
								multiple
								disableCloseOnSelect
								size="small"
								id="meal-cadence"
								className={classes.autoComplete}
								options={facility?.services?.grooming?.services || []}
								getOptionLabel={(option) => option.name}
								value={groomingOptions || []}
								onChange={(e, v) => addService(v)}
								onClose={(e) => {
									e.target.value = ''
								}}
								disabled={!pet.active}
								renderTags={(selected) =>
									selected.map((obj) => (
										<DeletableChip
											key={obj.type}
											label={obj.name}
											{...{
												onDelete: pet.active ? () => removeService(obj) : null
											}}
										/>
									))
								}
								renderOption={(option, { selected }) => (
									<React.Fragment>
										<Checkbox checked={selected} />
										<ListItemText
											style={{ textTransform: 'capitalize' }}
											primary={option.name}
										/>
									</React.Fragment>
								)}
								renderInput={(params) => (
									<TextField {...params} fullWidth variant="filled" label="Allowed Services" />
								)}
							/>
						</div>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])} style={{ marginBottom: 16 }}>
						<Autocomplete
							multiple
							disableCloseOnSelect
							size="small"
							id="meal-cadence"
							className={classes.autoComplete}
							options={groomingAddOnOptions || []}
							getOptionLabel={(option) => option.name}
							value={groomingAddOns || []}
							onChange={(e, v) => addAddOn(v)}
							onClose={(e) => {
								e.target.value = ''
							}}
							disabled={!pet.active}
							renderTags={(selected) =>
								selected.map((obj) => (
									<DeletableChip
										key={obj.type}
										label={obj.name}
										{...{
											onDelete: pet.active ? () => removeAddOn(obj) : null
										}}
									/>
								))
							}
							renderOption={(option, { selected }) => (
								<React.Fragment>
									<Checkbox checked={selected} />
									<ListItemText style={{ textTransform: 'capitalize' }} primary={option.name} />
								</React.Fragment>
							)}
							renderInput={(params) => (
								<TextField
									{...params}
									fullWidth
									variant="filled"
									label="Recommended Enrichments"
								/>
							)}
						/>
					</div>
					<div className={classes.rowSplit}>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])} style={{ width: '48%' }}>
							<TextField
								id="meal-instructions"
								variant="filled"
								label="Extra Groom Time (minutes)"
								fullWidth
								inputProps={{
									min: -99,
									max: 99
								}}
								type="number"
								value={pet.extra_groom_time}
								disabled={!pet.active || !canEditExtraGroomTime}
								helperText={
									!canEditExtraGroomTime
										? 'You do not have sufficient permissions to make this change. Please contact management team to make the necessary changes.'
										: undefined
								}
								onChange={(e) => {
									let val = e.target.value
									if (val < -99) val = -99
									if (val > 99) val = 99
									updatePet('extra_groom_time', val)
								}}
							/>
						</div>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])} style={{ width: '48%' }}>
							<TextField
								id="meal-instructions"
								variant="filled"
								label="Ear Cleaning"
								style={{ textTransform: 'capitalize' }}
								fullWidth
								value={pet.ear_cleaning}
								disabled={!pet.active}
								onChange={(e) => updatePet('ear_cleaning', e.target.value)}
								select>
								{['none', 'standard', 'trim', 'pluck', 'keep-dry'].map((option, index) => (
									<MenuItem key={index} style={{ textTransform: 'capitalize' }} value={option}>
										{option}
									</MenuItem>
								))}
							</TextField>
						</div>
					</div>
					<div className={classes.rowSplit}>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])} style={{ width: '48%' }}>
							<TextField
								id="meal-instructions"
								variant="filled"
								label="Nail Trim"
								style={{ textTransform: 'capitalize' }}
								fullWidth
								value={pet.nail_trimming}
								disabled={!pet.active}
								onChange={(e) => updatePet('nail_trimming', e.target.value)}
								select>
								{['standard', 'never'].map((option, index) => (
									<MenuItem key={index} style={{ textTransform: 'capitalize' }} value={option}>
										{option}
									</MenuItem>
								))}
							</TextField>
						</div>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])} style={{ width: '48%' }}>
							<TextField
								id="meal-instructions"
								variant="filled"
								label="Anal Glands"
								style={{ textTransform: 'capitalize' }}
								fullWidth
								value={pet.glands}
								disabled={!pet.active}
								select
								onChange={(e) => updatePet('glands', e.target.value)}>
								{['none', 'standard', 'always'].map((option, index) => (
									<MenuItem key={index} style={{ textTransform: 'capitalize' }} value={option}>
										{option}
									</MenuItem>
								))}
							</TextField>
						</div>
					</div>
					<Typography variant="body1" className={classes.sectionHeader}>
						Dog Coat
					</Typography>
					<div className={classes.stuff}>
						<TextField
							id="meal-instructions"
							variant="filled"
							label="Coat Length"
							select
							value={pet.coat_length}
							disabled={!pet.active}
							onChange={(e) => updatePet('coat_length', e.target.value)}>
							{coatOptions.map((option, index) => (
								<MenuItem key={index} value={option}>
									{option}
								</MenuItem>
							))}
						</TextField>
						<TextField
							id="meal-instructions"
							variant="filled"
							label="Coat Type"
							select
							value={pet.coat_type}
							disabled={!pet.active}
							onChange={(e) => updatePet('coat_type', e.target.value)}>
							{coatTypes.map((option, index) => (
								<MenuItem key={index} value={option}>
									{option}
								</MenuItem>
							))}
						</TextField>
					</div>
					<div className={classes.stuff}>

						<TextField
							id="meal-instructions"
							variant="filled"
							label="Shedding"
							select
							value={pet.shedding}
							style={{ textTransform: 'capitalize' }}
							disabled={!pet.active}
							onChange={(e) => updatePet('shedding', e.target.value)}>
							{sheddingOptions.map((option, index) => (
								<MenuItem key={index} style={{ textTransform: 'capitalize' }} value={option}>
									{option}
								</MenuItem>
							))}
						</TextField>
						<TextField
							id="meal-instructions"
							variant="filled"
							label="Breed Mix"
							select
							value={pet.breed_mix}
							disabled={!pet.active}
							style={{ textTransform: 'capitalize' }}
							onChange={(e) => updatePet('breed_mix', e.target.value)}>
							{['single', 'doodle', 'combo', 'unknown'].map((option, index) => (
								<MenuItem key={index} style={{ textTransform: 'capitalize' }} value={option}>
									{option}
								</MenuItem>
							))}
						</TextField>
					</div>

					<div className={classes.stuff}>


						<TextField
							id="meal-instructions"
							variant="filled"
							label="Duration Table"
							select
							value={pet.duration_table}
							helperText="Warning: Do not change this field unless you are sure that a dog should be assigned to a different table. Changing this will override the dog's calculated coat/ breed type assignment."
							disabled={!pet.active}
							style={{ textTransform: 'capitalize', maxWidth: 420 }}
							onChange={(e) => updatePet('duration_table', e.target.value)}>
							{duration_tables.sort().map((option, index) => (
								<MenuItem key={index} style={{ textTransform: 'capitalize' }} value={option}>
									{option}
								</MenuItem>
							))}
						</TextField>
					</div>

					<div className={classes.grid}>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
							<Typography
								variant="body2"
								style={{ fontWeight: 800, marginBottom: 16, marginTop: 8 }}>
								Grooming Tags
							</Typography>
							<Autocomplete
								multiple
								getOptionLabel={(option) => option.name || ''}
								disableCloseOnSelect
								size="small"
								id="meal-tags"
								className={classes.autoComplete}
								options={tags ? tags.grooming : []}
								value={petGroomingTags && petGroomingTags.length ? petGroomingTags : []}
								onChange={(e, v) => updateGroomingTags(v)}
								onClose={(e) => {
									e.target.value = ''
								}}
								disabled={!pet.active}
								renderTags={(selected) =>
									selected.map((value) => (
										<DeletableChip
											key={value._id}
											label={value.name}
											{...{
												onDelete: pet.active ? () => removeTag(value) : null
											}}
										/>
									))
								}
								renderOption={(option, { selected }) => (
									<React.Fragment>
										<Checkbox checked={selected} />
										<ListItemText
											style={{ textTransform: 'capitalize' }}
											primary={option.name}
										/>
									</React.Fragment>
								)}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="filled"
										fullWidth
										label="Select All Grooming Tags"
									/>
								)}
							/>
						</div>
					</div>
					<Typography variant="body1" className={classes.sectionHeader}>
						Grooming Notes
					</Typography>
					<div className={classes.stuff}>
						<DebouncedTextField
							id="meal-instructions"
							variant="filled"
							label="Client Grooming Notes"
							multiline
							fullWidth
							value={pet.client_grooming_notes}
							disabled={!pet.active}
							onChange={(e) => updatePet('client_grooming_notes', e.target.value)}
						/>
					</div>
					<div className={classes.stuff}>
						<DebouncedTextField
							id="meal-instructions"
							variant="filled"
							label="Team Grooming Notes"
							multiline
							fullWidth
							value={pet.team_grooming_notes}
							disabled={!pet.active}
							onChange={(e) => updatePet('team_grooming_notes', e.target.value)}
						/>
					</div>
					<GroomingDurationTable
						pet={pet}
						household={props.household}
						facility={facility}
						prices={facility?.groomingPricing || {}}
						addons={groomingAddOnOptions}
					/>
				</CardContent>
			</Collapse>
		</Card>
	)
}

export default GroomingServicesCard
